import { render } from "./animalIcon.vue?vue&type=template&id=9a94756a&scoped=true"
import script from "./animalIcon.vue?vue&type=script&lang=js"
export * from "./animalIcon.vue?vue&type=script&lang=js"

import "./animalIcon.vue?vue&type=style&index=0&id=9a94756a&lang=scss&scoped=true"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a94756a"]])

export default __exports__